export interface QuestionnaireSelectionOutputApiModel {
    id: number;
    name: string;
}

export interface QuestionnaireOutApiModel {
    id: number;
    title: string;
    isrequired?:boolean;
    isActive?:boolean;
    selections: QuestionnaireSelectionOutputApiModel[];
}